const getWithKey = (obj, key) => obj[key];
export {
  getWithKey
};
